module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousPoView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Air Freight Export")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-button-group', {
    attrs: {
      "size": "sm"
    }
  }, [_c('b-button', {
    attrs: {
      "disabled": _vm.AIR_BOOK == '0' ? true : false,
      "variant": _vm.AIR_BOOK == '0' ? '' : 'success'
    },
    on: {
      "click": function($event) {
        _vm.gotToPage('BOOK')
      }
    }
  }, [_vm._v("Booking")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.AIR_EXEC == '0' ? true : false,
      "variant": _vm.AIR_EXEC == '0' ? '' : 'success'
    },
    on: {
      "click": function($event) {
        _vm.gotToPage('EXEC')
      }
    }
  }, [_vm._v("Execution")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.AIR_TRACK == '0' ? true : false,
      "variant": _vm.AIR_TRACK == '0' ? '' : 'success'
    },
    on: {
      "click": function($event) {
        _vm.gotToPage('TRACK')
      }
    }
  }, [_vm._v("Tracking")])], 1)], 1)], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": this.AirFreightMain.allModuleId ? this.AirFreightMain.allModuleId : '',
      "jobSeriesBanner": this.AirFreightMain.airFFExportSeries ?
        this.AirFreightMain.airFFExportSeries :
        '',
      "bannerClientName": this.allShipperData[0].clientName ? this.allShipperData[0].clientName : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "shipmentType"
    }
  }, [_vm._v("Shipping Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shipmentTypeList,
      "option-value": "shipmentTypeVal",
      "option-text": "shipmentTypeText",
      "placeholder": "Select Shipment Type",
      "isDisabled": ""
    },
    model: {
      value: (_vm.AirFreightMain.shipmentType),
      callback: function($$v) {
        _vm.$set(_vm.AirFreightMain, "shipmentType", $$v)
      },
      expression: "AirFreightMain.shipmentType"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Export")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeList,
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "Select Transport Type",
      "isDisabled": ""
    },
    model: {
      value: (_vm.AirFreightMain.transportType),
      callback: function($$v) {
        _vm.$set(_vm.AirFreightMain, "transportType", $$v)
      },
      expression: "AirFreightMain.transportType"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "airFFType"
    }
  }, [_vm._v("FF Activity Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.containerInfoList,
      "option-value": "containerInfoVal",
      "option-text": "containerInfoText",
      "placeholder": "Select FF Activity"
    },
    model: {
      value: (_vm.AirFreightMain.airFFType),
      callback: function($$v) {
        _vm.$set(_vm.AirFreightMain, "airFFType", $$v)
      },
      expression: "AirFreightMain.airFFType"
    }
  }), _vm._v(" "), (!_vm.AirFreightMain.airFFType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.mainErrorList.airFFType))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "shipmentExecution"
    }
  }, [_vm._v("Shipment Execution")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shipmentExectionList,
      "option-value": "shipmentExectionVal",
      "option-text": "shipmentExectionTxt",
      "placeholder": "Select Shipment Exec"
    },
    model: {
      value: (_vm.AirFreightMain.shipmentExecution),
      callback: function($$v) {
        _vm.$set(_vm.AirFreightMain, "shipmentExecution", $$v)
      },
      expression: "AirFreightMain.shipmentExecution"
    }
  }), _vm._v(" "), (!_vm.AirFreightMain.shipmentExecution) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.mainErrorList.shipmentExecution))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("Airline")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.airLineList,
      "option-value": "airlineId",
      "option-text": "airlineName",
      "placeholder": "Select Airline"
    },
    model: {
      value: (_vm.AirFreightMain.airlineId),
      callback: function($$v) {
        _vm.$set(_vm.AirFreightMain, "airlineId", $$v)
      },
      expression: "AirFreightMain.airlineId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "airportDeparture"
    }
  }, [_vm._v("Departure Airport")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.getPortDischargeList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Airport"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'getPortDischargeList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'getPortDischargeList')
      }
    },
    model: {
      value: (_vm.AirFreightMain.airportDeparture),
      callback: function($$v) {
        _vm.$set(_vm.AirFreightMain, "airportDeparture", $$v)
      },
      expression: "AirFreightMain.airportDeparture"
    }
  }), _vm._v(" "), (!_vm.AirFreightMain.airportDeparture) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.mainErrorList.airportDeparture))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "airportDestination"
    }
  }, [_vm._v("Destination Airport")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.PortDestiList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Airport"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'PortDestiList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'PortDestiList')
      }
    },
    model: {
      value: (_vm.AirFreightMain.airportDestination),
      callback: function($$v) {
        _vm.$set(_vm.AirFreightMain, "airportDestination", $$v)
      },
      expression: "AirFreightMain.airportDestination"
    }
  }), _vm._v(" "), (!_vm.AirFreightMain.airportDestination) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.mainErrorList.airportDestination))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (
    _vm.AirFreightMain.airFFType == 'fclConsolidation' &&
    _vm.consoMultipleShipperTable.length > 0 &&
    _vm.airFreightModal.shipperFreightId == ''
  ) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "85"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-info",
      "size": "sm"
    },
    on: {
      "click": _vm.showMoreShipper
    }
  }, [_vm._v(_vm._s(_vm.openShipper == true ? "Hide" :
    "Add More") + " Clients")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-card', {
    staticClass: "mt-3"
  }, [(_vm.consoMultipleShipperTable.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('h5', [_c('b-badge', [_vm._v("Client Details")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "shiper"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr.no")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Cargo Details")]), _vm._v(" "), _c('th', [_vm._v("Other Details")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.consoMultipleShipperTable), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.viewEditShiper(item1)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item1.clientName) + "\n                      ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v("\n                          Cargo Received At : " + _vm._s(item1.cargoReceivedAt) + "\n                          "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                          Cargo Gross Weight : " + _vm._s(item1.cargoGrossWeight) + "\n                          " + _vm._s(item1.CargowgtUnit) + "\n                          "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                          Cargo Volume Weight : " + _vm._s(item1.cargoVolumeWeight) + "\n                          "), _c('br')])]), _vm._v(" "), _c('span', [_vm._v("\n                        CC Type : " + _vm._s(item1.ccType) + "\n                        "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                        Delivery Mode : " + _vm._s(item1.deliveryMode) + "\n                        "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                        Delivery Terms : " + _vm._s(item1.deliveryTerms) + "\n                        "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                        Chargeable Vol. Wgt. by System : " + _vm._s(item1.chargeVolWgtSys) + "\n                        "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                        Chargeable Vol. Wgt. by Airline : " + _vm._s(item1.chargeVolWgtAir) + "\n                        "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                        Final Chargeable Wgt. : " + _vm._s(item1.finalChargableWeight) + "\n                        "), _c('br')])])
  }))])])]) : _vm._e(), _vm._v(" "), (
    _vm.consoMultipleShipperTable.length <= 0 ||
    _vm.airFreightModal.shipperFreightId != '' ||
    _vm.openShipper == true
  ) ? _c('div', [_c('b-card', {
    staticClass: "gutr",
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Existing Client Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.airFreightModal.shipperFreightId == '' ? false : true,
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Existing Client Name"
    },
    model: {
      value: (_vm.airFreightModal.clientId),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "clientId", $$v)
      },
      expression: "airFreightModal.clientId"
    }
  }), _vm._v(" "), (!_vm.airFreightModal.clientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.shipperErrorList.clientId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('label', {
    attrs: {
      "for": "stuffingType"
    }
  }, [_vm._v("No.of Pkg")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "fff",
      "name": "bfffuyer"
    },
    model: {
      value: (_vm.airFreightModal.noOfPackageUnit),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "noOfPackageUnit", $$v)
      },
      expression: "airFreightModal.noOfPackageUnit"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', {
    attrs: {
      "for": "stuffingType"
    }
  }, [_vm._v("Cargo Received At")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.stuffingTypeList,
      "option-value": "stuffingTypeVal",
      "option-text": "stuffingTypeText",
      "placeholder": "Select Received At"
    },
    model: {
      value: (_vm.airFreightModal.cargoReceivedAt),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "cargoReceivedAt", $$v)
      },
      expression: "airFreightModal.cargoReceivedAt"
    }
  }), _vm._v(" "), (!_vm.airFreightModal.cargoReceivedAt) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.shipperErrorList.cargoReceivedAt))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.airFreightModal.cargoReceivedAt === 'pickup') ? _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "pickup_location"
    }
  }, [_vm._v("Pickup Location")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "pickup_location",
      "name": "pickup_location"
    },
    model: {
      value: (_vm.airFreightModal.pickup_location),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "pickup_location", $$v)
      },
      expression: "airFreightModal.pickup_location"
    }
  })], 1), _vm._v(" "), (_vm.airFreightModal.pickup_location_err ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                      " + _vm._s(_vm.airFreightModal.pickup_location_err) + "\n                    ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.airFreightModal.cargoReceivedAt === 'pickup') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', {
    attrs: {
      "for": "shipmentType"
    }
  }, [_vm._v("Source Of Booking")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.bookingSourceList,
      "option-value": "bookingSourceVal",
      "option-text": "bookingSourceText",
      "placeholder": "Select Source Of Booking "
    },
    model: {
      value: (_vm.airFreightModal.bookingSource),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "bookingSource", $$v)
      },
      expression: "airFreightModal.bookingSource"
    }
  }), _vm._v(" "), (!_vm.airFreightModal.bookingSource) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.shipperErrorList.bookingSource))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', [_vm._v("Type of Airway")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "value",
      "option-text": "text",
      "list": _vm.AirwayType,
      "placeholder": "Select B/L"
    },
    model: {
      value: (_vm.airFreightModal.typeAirway),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "typeAirway", $$v)
      },
      expression: "airFreightModal.typeAirway"
    }
  }), _vm._v(" "), (!_vm.airFreightModal.typeAirway) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.shipperErrorList.typeAirway))]) : _vm._e()], 1), _vm._v(" "), (_vm.airFreightModal.typeAirway == 'HouseAirwayBL') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.airFreightModal.typeAirway == 'HouseAirwayBL') ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Freight Terms For HAWB")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "value",
      "option-text": "text",
      "list": _vm.freightTerms,
      "placeholder": "Select Terms"
    },
    model: {
      value: (_vm.airFreightModal.HAWBTerms),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "HAWBTerms", $$v)
      },
      expression: "airFreightModal.HAWBTerms"
    }
  }), _vm._v(" "), (!_vm.airFreightModal.HAWBTerms) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.HAWBTermsError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.airFreightModal.typeAirway == 'HouseAirwayBL') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.airFreightModal.typeAirway == 'HouseAirwayBL') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Freight Terms For MAWB")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "value",
      "option-text": "text",
      "list": _vm.freightTerms,
      "placeholder": "Select Terms"
    },
    model: {
      value: (_vm.airFreightModal.MAWBTerms),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "MAWBTerms", $$v)
      },
      expression: "airFreightModal.MAWBTerms"
    }
  }), _vm._v(" "), (!_vm.airFreightModal.MAWBTerms) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.MAWBTermsError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.airFreightModal.typeAirway == 'DirectAirwayBL') ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Freight Terms")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "value",
      "option-text": "text",
      "list": _vm.freightTerms,
      "placeholder": "Select Terms"
    },
    model: {
      value: (_vm.airFreightModal.freightTerms),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "freightTerms", $$v)
      },
      expression: "airFreightModal.freightTerms"
    }
  }), _vm._v(" "), (!_vm.airFreightModal.freightTerms) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.freightTermsError))]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.airFreightModal.bookingSource == 'Destination') ? _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "agentName"
    }
  }, [_vm._v("Agent Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.agentNameList,
      "option-value": "agntColoaderId",
      "option-text": "agentName",
      "placeholder": "Select Agent Name"
    },
    model: {
      value: (_vm.airFreightModal.agentName),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "agentName", $$v)
      },
      expression: "airFreightModal.agentName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.airFreightModal.bookingSource == 'Origin') ? _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "sourceOriginclientId"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    model: {
      value: (_vm.airFreightModal.sourceOriginclientId),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "sourceOriginclientId", $$v)
      },
      expression: "airFreightModal.sourceOriginclientId"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.airFreightModal.bookingSource == 'Destination') ? _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Buyer Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "buyer",
      "name": "buyer"
    },
    model: {
      value: (_vm.airFreightModal.buyer),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "buyer", $$v)
      },
      expression: "airFreightModal.buyer"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.airFreightModal.bookingSource == 'Origin') ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Buying House")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "buyingHouse",
      "name": "buyingHouse"
    },
    model: {
      value: (_vm.airFreightModal.buyingHouse),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "buyingHouse", $$v)
      },
      expression: "airFreightModal.buyingHouse"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.airFreightModal.bookingSource == 'Origin') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Other Specify")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "otherSpecify",
      "name": "otherSpecify"
    },
    model: {
      value: (_vm.airFreightModal.otherSpecify),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "otherSpecify", $$v)
      },
      expression: "airFreightModal.otherSpecify"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "ccType"
    }
  }, [_vm._v("CC Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.cctypeList,
      "option-value": "ccTypeVal",
      "option-text": "ccTypeTxt",
      "placeholder": "Select CC Type"
    },
    model: {
      value: (_vm.airFreightModal.ccType),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "ccType", $$v)
      },
      expression: "airFreightModal.ccType"
    }
  })], 1), _vm._v(" "), (_vm.airFreightModal.ccType == 'Outsourced') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.airFreightModal.ccType == 'Outsourced') ? _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("CHA Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.chaNameList,
      "option-value": "agntColoaderId",
      "option-text": "agentName",
      "placeholder": "Select CHA "
    },
    model: {
      value: (_vm.airFreightModal.ccCha),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "ccCha", $$v)
      },
      expression: "airFreightModal.ccCha"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryMode"
    }
  }, [_vm._v("Destination Delivery Mode")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.deliveryModeList,
      "option-value": "deliveryModeVal",
      "option-text": "deliveryModeText",
      "placeholder": "Select Delivery Mode"
    },
    model: {
      value: (_vm.airFreightModal.deliveryMode),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "deliveryMode", $$v)
      },
      expression: "airFreightModal.deliveryMode"
    }
  }), _vm._v(" "), (!_vm.airFreightModal.deliveryMode) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.shipperErrorList.deliveryMode))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.airFreightModal.deliveryMode === 'fpod') ? _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "fpod_location"
    }
  }, [_vm._v("FPOD Location")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "fpodLocation",
      "name": "fpod_location"
    },
    model: {
      value: (_vm.airFreightModal.fpod_location),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "fpod_location", $$v)
      },
      expression: "airFreightModal.fpod_location"
    }
  })], 1), _vm._v(" "), (_vm.airFreightModal.fpod_location_err ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                      " + _vm._s(_vm.airFreightModal.fpod_location_err) + "\n                    ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.airFreightModal.deliveryMode === 'fpod') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.airFreightModal.deliveryMode == 'Door') ? _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "doorFpod"
    }
  }, [_vm._v("Final Place of Delivery")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceData,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select FPOD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'finalAllPlaceData')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Air_Port', 'finalAllPlaceData')
      }
    },
    model: {
      value: (_vm.airFreightModal.doorFpod),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "doorFpod", $$v)
      },
      expression: "airFreightModal.doorFpod"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.airFreightModal.deliveryMode == 'Door') ? _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryMode"
    }
  }, [_vm._v("Door Add")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    model: {
      value: (_vm.airFreightModal.door_add),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "door_add", $$v)
      },
      expression: "airFreightModal.door_add"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryTerms"
    }
  }, [_vm._v("Delivery Terms(INCOTERMS)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.deliveryTermsList,
      "option-value": "deliveryTermsVal",
      "option-text": "deliveryTermsText",
      "placeholder": "Select Delivery Terms"
    },
    model: {
      value: (_vm.airFreightModal.deliveryTerms),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "deliveryTerms", $$v)
      },
      expression: "airFreightModal.deliveryTerms"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "autoCommodity"
    }
  }, [_vm._v("Commodity")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.commodityList,
      "option-value": "commodityId",
      "option-text": "itemDescription",
      "placeholder": "Select Commodity"
    },
    model: {
      value: (_vm.airFreightModal.commodityId),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "commodityId", $$v)
      },
      expression: "airFreightModal.commodityId"
    }
  }), _vm._v(" "), (!_vm.airFreightModal.commodityId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.shipperErrorList.commodityId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "commodityType"
    }
  }, [_vm._v("Commodity Type")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "commodityType",
      "name": "commodityType",
      "disabled": ""
    },
    model: {
      value: (_vm.airFreightModal.commodityType),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "commodityType", $$v)
      },
      expression: "airFreightModal.commodityType"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.airFreightModal.commodityType == 'Hazardous') ? _c('md-layout', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("IMDG Class")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "IMDGClass",
      "name": "IMDGClass"
    },
    model: {
      value: (_vm.airFreightModal.IMDGClass),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "IMDGClass", $$v)
      },
      expression: "airFreightModal.IMDGClass"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("UN Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "UNNumber",
      "name": "UNNumber"
    },
    model: {
      value: (_vm.airFreightModal.UNNumber),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "UNNumber", $$v)
      },
      expression: "airFreightModal.UNNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Packing Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "packingCode",
      "name": "packingCode"
    },
    model: {
      value: (_vm.airFreightModal.packingCode),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "packingCode", $$v)
      },
      expression: "airFreightModal.packingCode"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.airFreightModal.commodityType == 'Reefer') ? _c('md-layout', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Temperature Req(Degree Celsius)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "temperatureRequired",
      "name": "temperatureRequired"
    },
    model: {
      value: (_vm.airFreightModal.temperatureRequired),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "temperatureRequired", $$v)
      },
      expression: "airFreightModal.temperatureRequired"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.airFreightModal.commodityType == 'Others') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Specific Detail if any..!")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "otherComodity",
      "name": "otherComodity"
    },
    model: {
      value: (_vm.airFreightModal.otherComodity),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "otherComodity", $$v)
      },
      expression: "airFreightModal.otherComodity"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Additional Task")])], 1)])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, _vm._l((_vm.showOtherServiceArray), function(otherServiceNameArray, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": otherServiceNameArray.flex
      }
    }, [_c('md-checkbox', {
      staticClass: "md-primary",
      attrs: {
        "md-value": otherServiceNameArray.value,
        "name": 'otherServices' + (index + 1),
        "id": 'otherServices' + (index + 1)
      },
      on: {
        "change": function($event) {
          _vm.otherServiceNameArraySelect(otherServiceNameArray.value, index)
        }
      },
      model: {
        value: (_vm.airFreightModal.otherServices[index]),
        callback: function($$v) {
          _vm.$set(_vm.airFreightModal.otherServices, index, $$v)
        },
        expression: "airFreightModal.otherServices[index]"
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-top": "17px"
      }
    }, [_vm._v(_vm._s(otherServiceNameArray.show))])], 1)
  })), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.showAdd == true) ? _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Specify Additional Task")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "specificAdditionalTask",
      "name": "specificAdditionalTask"
    },
    model: {
      value: (_vm.airFreightModal.specificAdditionalTask),
      callback: function($$v) {
        _vm.$set(_vm.airFreightModal, "specificAdditionalTask", $$v)
      },
      expression: "airFreightModal.specificAdditionalTask"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('b-button', {
    staticClass: "pull-right smbutnWidth",
    attrs: {
      "variant": "primary",
      "size": "sm",
      "id": "addButtonLoaderMid"
    },
    on: {
      "click": _vm.addMainWithShipper
    }
  }, [_vm._v(_vm._s(_vm.airFreightModal.shipperFreightId != "" ? "Save" : "Save"))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderMid"
    }
  })], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.allShipperData.length > 0) ? _c('div', [(_vm.showPackageSection != null && _vm.showPackageSection != '') ? _c('b-card', {
    staticClass: "mt-3"
  }, [_c('div', [(_vm.AirFreightMain.airFFType == 'fclConsolidation') ? _c('b-button', {
    attrs: {
      "variant": "outline-success",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.addPackModal('1')
      }
    }
  }, [_vm._v("Add Package For Another Client")]) : _vm._e()], 1), _vm._v(" "), (_vm.packageDetails.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', [_c('h5', [_c('b-badge', [_vm._v("Package Details")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "portLocationNew"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr.no")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("No.of Package")]), _vm._v(" "), _c('th', [_vm._v("Package Length")]), _vm._v(" "), _c('th', [_vm._v("Package Width")]), _vm._v(" "), _c('th', [_vm._v("Package Height")]), _vm._v(" "), _c('th', [_vm._v("Unit")]), _vm._v(" "), _c('th', [_vm._v("Package Volume")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.packageDetails), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.clientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.noOfPackage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.packageLength))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.packageWidth))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.packageHeight))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.packageUnit))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.packageVolume))]), _vm._v(" "), _c('td', [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-danger"
      },
      on: {
        "click": function($event) {
          _vm.viewEditPackage(item1)
        }
      }
    }, [_vm._v("Edit\n                            Package")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-danger"
      },
      on: {
        "click": function($event) {
          _vm.removeCommon(item1)
        }
      }
    }, [_vm._v("Delete")])], 1)])
  }))])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "packagePop",
    attrs: {
      "size": _vm.showPakg == false ? 'xl' : '',
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "scrollable": "",
      "id": "myDIV",
      "hide-footer": "",
      "title": "Package Details"
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('b-card', [_c('b-card-text', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "sourceOriginclientId"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.packageClientList,
      "id": "clientNamenew",
      "option-value": "shipperFreightId",
      "option-text": "clientName",
      "placeholder": "Select Client Name",
      "isDisabled": _vm.airPackageModal.cargoId != '' ? true : false
    },
    model: {
      value: (_vm.airPackageModal.shipperFreightId),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "shipperFreightId", $$v)
      },
      expression: "airPackageModal.shipperFreightId"
    }
  }), _vm._v(" "), (!_vm.airPackageModal.shipperFreightId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.packageErrorList.shipperFreightId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.airPackageModal.shipperFreightId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', [_vm._v("Total Packages of Client")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.AirFreightMain.airFFType == 'fclConsolidation' ?
        false :
        true,
      "id": "noOfPackageUnit",
      "name": "noOfPackageUnit",
      "type": "number"
    },
    model: {
      value: (_vm.airPackageModal.noOfPackageUnit),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "noOfPackageUnit", $$v)
      },
      expression: "airPackageModal.noOfPackageUnit"
    }
  }), _vm._v(" "), (!_vm.airPackageModal.noOfPackageUnit) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.packageErrorList.noOfPackageUnit))]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [(
    _vm.airPackageModal.shipperFreightId != '' && _vm.showPakg == true
  ) ? _c('div', {
    staticClass: "col-md-12 grid-margin stretch-card"
  }, [_c('span', {
    staticClass: "error"
  }, [_vm._v("Remaining Packages to be added =\n                              " + _vm._s(_vm.packagePending))]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Package Details")]), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("No. Of Packages")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "noOfPackage",
      "name": "noOfPackage",
      "type": "number"
    },
    on: {
      "keyup": _vm.VolumeWeightCargoAmount
    },
    model: {
      value: (_vm.airPackageModal.noOfPackage),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "noOfPackage", $$v)
      },
      expression: "airPackageModal.noOfPackage"
    }
  })], 1), _vm._v(" "), (!_vm.airPackageModal.noOfPackage) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.packageErrorList.noOfPackage))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Length")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "packageLength",
      "name": "packageLength",
      "type": "number"
    },
    on: {
      "keyup": _vm.VolumeWeightCargoAmount
    },
    model: {
      value: (_vm.airPackageModal.packageLength),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "packageLength", $$v)
      },
      expression: "airPackageModal.packageLength"
    }
  })], 1), _vm._v(" "), (!_vm.airPackageModal.packageLength) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.packageErrorList.packageLength))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Width")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "packageWidth",
      "name": "packageWidth",
      "type": "number"
    },
    on: {
      "keyup": _vm.VolumeWeightCargoAmount
    },
    model: {
      value: (_vm.airPackageModal.packageWidth),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "packageWidth", $$v)
      },
      expression: "airPackageModal.packageWidth"
    }
  })], 1), _vm._v(" "), (!_vm.airPackageModal.packageWidth) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.packageErrorList.packageWidth))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Height")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "packageHeight",
      "name": "packageHeight",
      "type": "number"
    },
    on: {
      "keyup": _vm.VolumeWeightCargoAmount
    },
    model: {
      value: (_vm.airPackageModal.packageHeight),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "packageHeight", $$v)
      },
      expression: "airPackageModal.packageHeight"
    }
  })], 1), _vm._v(" "), (!_vm.airPackageModal.packageHeight) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.packageErrorList.packageHeight))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryTerms1"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.pkgwgtUnitList,
      "option-value": "pkgwgtUnitVal",
      "option-text": "pkgwgtUnitText",
      "placeholder": "Select "
    },
    on: {
      "input": _vm.VolumeWeightCargoAmount
    },
    model: {
      value: (_vm.airPackageModal.packageUnit),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "packageUnit", $$v)
      },
      expression: "airPackageModal.packageUnit"
    }
  }), _vm._v(" "), (!_vm.airPackageModal.packageUnit) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.packageErrorList.packageUnit))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Package Volume")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "packageVolume",
      "name": "packageVolume",
      "disabled": ""
    },
    model: {
      value: (_vm.airPackageModal.packageVolume),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "packageVolume", $$v)
      },
      expression: "airPackageModal.packageVolume"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "id": "addButtonLoaderpackage"
    },
    on: {
      "click": _vm.addPackage
    }
  }, [_vm._v(_vm._s(_vm.airPackageModal.cargoId != "" ? "Edit" : "Add") + "\n                                      Package")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderpackage"
    }
  })], 1)], 1)], 1)])]) : _vm._e(), _vm._v(" "), (
    _vm.airPackageModal.shipperFreightId != '' &&
    _vm.showCharge == true
  ) ? _c('div', {
    staticClass: "col-md-12 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Cargo Details")]), _vm._v(" "), (_vm.airPackageModal.shipperFreightId != '') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.airPackageModal.shipperFreightId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Package Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.packageNameList,
      "id": "clientId",
      "option-value": "packageId",
      "option-text": "packageName",
      "placeholder": "Select  Package "
    },
    model: {
      value: (_vm.airPackageModal.packageIdUnit),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "packageIdUnit", $$v)
      },
      expression: "airPackageModal.packageIdUnit"
    }
  }), _vm._v(" "), (!_vm.airPackageModal.packageIdUnit) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.packageErrorList.packageIdUnit))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Cargo Gross Weight")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "cargoGrossWeight",
      "name": "cargoGrossWeight",
      "type": "number"
    },
    on: {
      "keyup": _vm.VolumeWeightBySysAmount
    },
    model: {
      value: (_vm.airPackageModal.cargoGrossWeight),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "cargoGrossWeight", $$v)
      },
      expression: "airPackageModal.cargoGrossWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryTerms"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.CargowgtUnitList,
      "option-value": "CargowgtUnitVal",
      "option-text": "CargowgtUnitText",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.airPackageModal.CargowgtUnit),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "CargowgtUnit", $$v)
      },
      expression: "airPackageModal.CargowgtUnit"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Chargeable Vol.Wgt By Airline")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "chargeVolWgtAir",
      "name": "chargeVolWgtAir",
      "type": "number"
    },
    on: {
      "keyup": _vm.FinalVolumeWeightAmount
    },
    model: {
      value: (_vm.airPackageModal.chargeVolWgtAir),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "chargeVolWgtAir", $$v)
      },
      expression: "airPackageModal.chargeVolWgtAir"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.airPackageModal.shipperFreightId != '' &&
    _vm.packageDetails.length > 0
  ) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Volume Weight of Cargo")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "cargoVolumeWeight",
      "name": "cargoVolumeWeight",
      "type": "number",
      "disabled": ""
    },
    model: {
      value: (_vm.airPackageModal.cargoVolumeWeight),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "cargoVolumeWeight", $$v)
      },
      expression: "airPackageModal.cargoVolumeWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Chargeable Vol.Wgt By System")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "chargeVolWgtSys",
      "name": "chargeVolWgtSys",
      "disabled": ""
    },
    model: {
      value: (_vm.airPackageModal.chargeVolWgtSys),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "chargeVolWgtSys", $$v)
      },
      expression: "airPackageModal.chargeVolWgtSys"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Final Chargeable Weight")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "finalChargableWeight",
      "name": "finalChargableWeight",
      "disabled": ""
    },
    model: {
      value: (_vm.airPackageModal.finalChargableWeight),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "finalChargableWeight", $$v)
      },
      expression: "airPackageModal.finalChargableWeight"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.airPackageModal.shipperFreightId != '' &&
    _vm.packageDetails.length > 0
  ) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [(
    _vm.airPackageModal.shipperFreightId != '' &&
    _vm.packageDetails.length > 0
  ) ? _c('b-button', {
    attrs: {
      "variant": "info",
      "size": "sm",
      "id": "addButtonLoaderMultiple"
    },
    on: {
      "click": _vm.updateCargo
    }
  }, [_vm._v("Update")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderMultiple"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e()], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.closeMerge
    }
  }, [_vm._v("Close")]), _vm._v(" "), (
    _vm.airPackageModal.shipperFreightId != '' &&
    _vm.packagePending != '0'
  ) ? _c('b-button', {
    staticClass: "pull-right mr-2",
    attrs: {
      "variant": "outline-success"
    },
    on: {
      "click": _vm.addMorePKG
    }
  }, [_vm._v("Add\n                            More")]) : _vm._e()], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-3"
  }, [_c('b-badge', [_vm._v("Airline Charges")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "sourceOriginclientId"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.packageClientList,
      "id": "clientNamenew",
      "option-value": "shipperFreightId",
      "option-text": "clientName",
      "placeholder": "Select Client Name",
      "isDisabled": _vm.airPackageModal.cargoId != '' ? true : false
    },
    model: {
      value: (_vm.airPackageModal.shipperFreightId),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "shipperFreightId", $$v)
      },
      expression: "airPackageModal.shipperFreightId"
    }
  }), _vm._v(" "), (!_vm.airPackageModal.shipperFreightId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.packageErrorList.shipperFreightId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.airPackageModal.shipperFreightId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', [_vm._v("Total Packages of Client")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": _vm.AirFreightMain.airFFType == 'fclConsolidation' ? false : true,
      "id": "noOfPackageUnit",
      "name": "noOfPackageUnit",
      "type": "number"
    },
    model: {
      value: (_vm.airPackageModal.noOfPackageUnit),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "noOfPackageUnit", $$v)
      },
      expression: "airPackageModal.noOfPackageUnit"
    }
  }), _vm._v(" "), (!_vm.airPackageModal.noOfPackageUnit) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.packageErrorList.noOfPackageUnit))]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [(_vm.airPackageModal.shipperFreightId != '') ? _c('div', {
    staticClass: "col-md-12 grid-margin stretch-card"
  }, [(_vm.airPackageModal.shipperFreightId != '') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.airPackageModal.shipperFreightId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Package Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.packageNameList,
      "id": "clientId",
      "option-value": "packageId",
      "option-text": "packageName",
      "placeholder": "Select  Package "
    },
    model: {
      value: (_vm.airPackageModal.packageIdUnit),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "packageIdUnit", $$v)
      },
      expression: "airPackageModal.packageIdUnit"
    }
  }), _vm._v(" "), (!_vm.airPackageModal.packageIdUnit) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.packageErrorList.packageIdUnit))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Cargo Gross Weight")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "cargoGrossWeight",
      "name": "cargoGrossWeight",
      "type": "number"
    },
    on: {
      "keyup": _vm.VolumeWeightBySysAmount
    },
    model: {
      value: (_vm.airPackageModal.cargoGrossWeight),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "cargoGrossWeight", $$v)
      },
      expression: "airPackageModal.cargoGrossWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryTerms"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.CargowgtUnitList,
      "option-value": "CargowgtUnitVal",
      "option-text": "CargowgtUnitText",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.airPackageModal.CargowgtUnit),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "CargowgtUnit", $$v)
      },
      expression: "airPackageModal.CargowgtUnit"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Volume Weight of Cargo")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "cargoVolumeWeight",
      "name": "cargoVolumeWeight",
      "type": "number",
      "disabled": ""
    },
    model: {
      value: (_vm.airPackageModal.cargoVolumeWeight),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "cargoVolumeWeight", $$v)
      },
      expression: "airPackageModal.cargoVolumeWeight"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.airPackageModal.shipperFreightId != '' &&
    _vm.packageDetails.length > 0
  ) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Chargeable Vol.Wgt By Airline")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "chargeVolWgtAir",
      "name": "chargeVolWgtAir",
      "type": "number"
    },
    on: {
      "keyup": _vm.FinalVolumeWeightAmount
    },
    model: {
      value: (_vm.airPackageModal.chargeVolWgtAir),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "chargeVolWgtAir", $$v)
      },
      expression: "airPackageModal.chargeVolWgtAir"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Chargeable Vol.Wgt By System")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "chargeVolWgtSys",
      "name": "chargeVolWgtSys",
      "disabled": ""
    },
    model: {
      value: (_vm.airPackageModal.chargeVolWgtSys),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "chargeVolWgtSys", $$v)
      },
      expression: "airPackageModal.chargeVolWgtSys"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Final Chargeable Weight")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "finalChargableWeight",
      "name": "finalChargableWeight",
      "disabled": ""
    },
    model: {
      value: (_vm.airPackageModal.finalChargableWeight),
      callback: function($$v) {
        _vm.$set(_vm.airPackageModal, "finalChargableWeight", $$v)
      },
      expression: "airPackageModal.finalChargableWeight"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.airPackageModal.shipperFreightId != '' &&
    _vm.packageDetails.length > 0
  ) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [(
    _vm.airPackageModal.shipperFreightId != '' &&
    _vm.packageDetails.length > 0
  ) ? _c('b-button', {
    attrs: {
      "variant": "info",
      "size": "sm",
      "id": "addButtonLoaderMultiple"
    },
    on: {
      "click": _vm.updateCargo
    }
  }, [_vm._v("Update")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderMultiple"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (_vm.AtleastOnePackage.length > 0) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    staticClass: "error",
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  }, [_c('u', [_vm._v("Note:")]), _vm._v("\n                    Select aleast one package details for\n                    " + _vm._s(_vm.AtleastOnePackage.join(", ")) + "\n                  ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.PackageNotMatch.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    staticClass: "error"
  }, [_c('u', [_vm._v("Note:")]), _vm._v("\n                    Total package is not equal to no of packages for\n                    " + _vm._s(_vm.PackageNotMatch.join(", ")) + "\n                  ")])])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.openShipper != true && _vm.packageDetails.length > 0) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderpro"
    },
    on: {
      "click": _vm.proceedBooking
    }
  }, [_vm._v("Save &\n                  Proceed To Booking Order")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderpro"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "my-modal",
    attrs: {
      "hide-footer": "",
      "title": ""
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('h3', [_vm._v("\n          Package Confirmation\n          "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "my-4"
  }, [_vm._v("\n          This Assignment has " + _vm._s(_vm.airPackageModal.noOfPackageUnit) + " Packages\n        ")])]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-success",
      "block": ""
    },
    on: {
      "click": _vm.yesModal
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.noModal
    }
  }, [_vm._v("No")])], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopError",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.goToBookingPage
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop1",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9bae1b20","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/airFreight/airFFExportConsol.vue
// module id = 2812
// module chunks = 0